import CityPageTemplate from "../city-template/CityPageTemplate";
import { salinasConfig } from "./data";

export default function SalinasPage() {
  return <CityPageTemplate config={salinasConfig} />;
}